import { Injectable } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { noSpacesValidator } from '@core/validators/no-spaces.validator'
import { Company, UpdateWarrantyInput, Warranty } from '@generated/sammathnaur.graphql'
import { WarrantyForm } from '../warranties-equipment-tab.types'

@Injectable({ providedIn: 'root' })
export class WarrantiesMapperService {

  public mapperWarrantyFormToInput(form: FormGroup<WarrantyForm>): UpdateWarrantyInput {
    return {
      id: form.value.id!,
      name: form.value.name!,
      description: form.value.description ?? '',
      value: Number(form.value.value),
      coverageDurationDays: Number(form.value.coverageDurationDays),
      extendedCoverageDurationDays: Number(form.value.extendedCoverageDurationDays),
      extendedValue: Number(form.value.extendedValue),
      coverageStartedAt: form.value.coverageStartedAt,
      companyId: form.value.company?.id ?? null,
    }
  }

  public createForm(this: void, warranty: Warranty): FormGroup<WarrantyForm> {
    const extendedCoverageDurationDaysValidators = warranty.extendedCoverageDurationDays ? [Validators.required, Validators.min(1), Validators.max(2147483647)] : []
    const extendedValueValidators = warranty.extendedCoverageDurationDays ? [Validators.min(1), Validators.max(99999999.99)] : []
    return new FormGroup({
      id: new FormControl<string>(warranty.id!),
      name: new FormControl<string | null>(warranty.name ?? null),
      description: new FormControl<string | null>(warranty.description ?? null, [Validators.maxLength(2000), Validators.required, noSpacesValidator()]),
      value: new FormControl<number | null>(warranty.value ?? null, [Validators.required, Validators.min(0), Validators.max(99999999.99)]),
      coverageDurationDays: new FormControl<number | null>(warranty.coverageDurationDays ?? null, [Validators.required, Validators.min(1), Validators.max(2147483647)]),
      extendedCoverageDurationDays: new FormControl<number | null>(warranty.extendedCoverageDurationDays ?? null, extendedCoverageDurationDaysValidators),
      extendedValue: new FormControl<number | null>(warranty.extendedValue ?? null, extendedValueValidators),
      coverageStartedAt: new FormControl<string | null>(warranty.startDate ?? null),

      hasCoverageExtend: new FormControl<boolean>(Boolean(warranty.extendedCoverageDurationDays)),

      coverageEndedAt: new FormControl<string | null>(warranty.endDate ?? null),
      extendedCoverageEndedAt: new FormControl<string | null>(warranty.extendedEndDate ?? null),

      company: new FormControl<Company | null>(warranty.company ?? null),
    })
  }
}


